var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 309,
    viewBox: "0 0 360 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 288.054C239.807 288.054 295.185 232.677 295.185 164.126C295.185 95.5748 239.563 40.1973 171.5 40.1973C103.193 40.1973 47.8154 95.5748 47.8154 164.126C47.8154 232.677 103.193 288.054 171.5 288.054Z",
    fill: "#F3F1FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.133 82.887C292.657 82.887 297.135 78.4089 297.135 72.8849C297.135 67.3609 292.657 62.8828 287.133 62.8828C281.609 62.8828 277.131 67.3609 277.131 72.8849C277.131 78.4089 281.609 82.887 287.133 82.887Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.771 43.8548C305.544 43.8548 308.602 40.7966 308.602 37.0241C308.602 33.2516 305.544 30.1934 301.771 30.1934C297.999 30.1934 294.94 33.2516 294.94 37.0241C294.94 40.7966 297.999 43.8548 301.771 43.8548Z",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.401 82.6419C58.1735 82.6419 61.2317 79.5837 61.2317 75.8112C61.2317 72.0387 58.1735 68.9805 54.401 68.9805C50.6285 68.9805 47.5703 72.0387 47.5703 75.8112C47.5703 79.5837 50.6285 82.6419 54.401 82.6419Z",
    fill: "#E4DAFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6856 214.379C19.6917 214.379 25.3712 208.699 25.3712 201.693C25.3712 194.687 19.6917 189.008 12.6856 189.008C5.67954 189.008 0 194.687 0 201.693C0 208.699 5.67954 214.379 12.6856 214.379Z",
    fill: "#E4DAFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360 125.212H347.897V113.109H337.523V125.212H325.42V135.932H337.523V148.035H347.897V135.932H360V125.212Z",
    fill: "#FD561F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.712 10.6821H149.366V0.335938H140.498V10.6821H130.151V19.8459H140.498V30.1921H149.366V19.8459H159.712V10.6821Z",
    fill: "#F7AD3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.943 113.904H29.1032V105.064H21.5263V113.904H12.6865V121.734H21.5263V130.573H29.1032V121.734H37.943V113.904Z",
    fill: "#19AE57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3092_18478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.504 140.223L234.076 80.5727C229.72 69.9682 218.358 63.9085 207.186 66.3702L144.127 80.0046C138.824 81.1408 134.28 84.7388 131.628 89.473L71.5992 203.85C69.1374 208.585 70.8417 214.644 75.7652 217.106L184.462 274.295C189.196 276.757 195.256 275.052 197.717 270.129L257.747 155.751C260.398 151.017 260.587 145.336 258.504 140.223ZM198.096 116.174C190.332 112.197 187.302 102.539 191.468 94.7752C195.445 87.0112 205.103 83.9813 212.867 88.1474C220.631 92.1241 223.661 101.782 219.495 109.546C215.518 117.31 205.86 120.34 198.096 116.174Z",
    fill: "url(#paint0_linear_3092_18478)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M195.479 198.53C199.473 200.741 204.792 199.213 207.003 195.219C209.214 191.224 207.686 185.905 203.691 183.694C199.697 181.483 194.378 183.012 192.167 187.006C189.798 191.285 191.199 196.161 195.479 198.53Z",
    fill: "#15112D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M172.718 208.965L169.009 206.912C169.661 198.328 162.809 191.18 154.351 190.971C151.152 190.691 147.606 191.71 145.043 193.646L141.334 191.592C149.369 184.485 162.167 185.606 168.831 193.768C171.877 197.691 173.691 203.168 172.718 208.965Z",
    fill: "#15112D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M138.418 166.942C142.412 169.153 147.731 167.625 149.942 163.631C152.153 159.636 150.625 154.317 146.631 152.106C142.637 149.895 137.318 151.424 135.107 155.418C133.023 159.855 134.424 164.731 138.418 166.942Z",
    fill: "#15112D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.86 101.593C255.284 76.0286 274.789 37.9659 249.035 21.491C223.281 5.01612 197.906 21.491 191.468 69.4008",
    stroke: "#7647EE",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3092_18478",
    x: 48.4824,
    y: 54.8242,
    width: 233.437,
    height: 253.588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3092_18478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3092_18478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3092_18478",
    x1: 165.139,
    y1: 60.9763,
    x2: 165.139,
    y2: 277.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEmptyState);
export default __webpack_public_path__ + "static/media/tagEmptyState.4a4950e6573f2fc6f5d80915f4c16989.svg";
export { ForwardRef as ReactComponent };